export default "__VITE_ASSET__BCs6f5Kf__"